export default "__VITE_ASSET__8e59f156__"